import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';


export const fetchLeaderBoard = createAsyncThunk(
    'leaderBoard/fetchLeaderBoard',
    async (organizationId, { rejectWithValue }) => {
        const jwtToken = localStorage.getItem("jwt_token");
        const URL = `${process.env.REACT_APP_API_URL}/leaderboard`;
        try {
            const response = await axios.get(`${URL}/${organizationId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            });
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const leaderboardSlice = createSlice({
    name: 'leaderBoard',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        clearLeaderBoard: (state) => {
            state.data = [];
            state.error = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLeaderBoard.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLeaderBoard.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchLeaderBoard.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearLeaderBoard } = leaderboardSlice.actions;
export default leaderboardSlice.reducer;
